"use client";

import * as React from "react";
import { SelectMyImageCropDialog } from "@/components/SelectMyImage";
import type { ImageCropRectNorm } from "../../../kernel/nodes/imageBlock.types";

/**
 * 富文本图片块裁切：复用 `SelectMyImageCropDialog`，不锁定比例（显示比例选项，默认「任意」）。
 */
export function ImageCropDialog({
  open,
  onOpenChange,
  imageSrc,
  initialCropNorm,
  onConfirm,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  imageSrc: string;
  initialCropNorm: ImageCropRectNorm | null;
  onConfirm: (crop: ImageCropRectNorm) => void;
}) {
  return (
    <SelectMyImageCropDialog
      open={open}
      onOpenChange={onOpenChange}
      imageUrl={imageSrc}
      initialNormalizedCrop={initialCropNorm}
      confirmLabel="好了"
      description="仅记录裁切区域坐标，不修改原图；正文以遮罩方式显示选定区域。"
      contentClassName="z-[400] flex h-[min(90vh,820px)] max-h-[90vh] min-h-0 w-full max-w-3xl flex-col gap-0 overflow-hidden p-0"
      dataImageCropDialog
      onConfirm={(norm) => {
        onConfirm(norm);
        onOpenChange(false);
      }}
    />
  );
}
